import React from 'react';
export default function NotFound() {
  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '1rem', color: '#F5F0E8' }}>
      <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '1.5rem', fontWeight: 800 }}>NotFound</div>
      <div style={{ fontSize: '0.85rem', color: 'rgba(245,240,232,0.5)' }}>Coming soon &mdash; currently being built</div>
    </div>
  );
}
